import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loadCustomerRequested } from 'store/customers/customersSlice';
import { loadAdditionalPapersRequested } from 'store/additional-papers/additionalpapersSlice';

export function useLoadCustomer(id: any) {
  const dispatch = useDispatch();
  const onLoadCustomer = useCallback(async () => {
    await dispatch(loadCustomerRequested({ reference: id }));
  }, [dispatch, id]);
  useEffect(() => {
    onLoadCustomer();
  }, [onLoadCustomer]);
  return { onLoadCustomer };
}

export function useLoadAdditionalPapers(ref: string) {
  const dispatch = useDispatch();

  const onLoadAdditionalPapers = useCallback(
    async () => {
      await dispatch(
        loadAdditionalPapersRequested({
          filters: { reference: ref, query: '' },
          page:1,
          perPage:3,
          reference: ref
        })
      );
    },
    [dispatch]
  );
  useEffect(() => {
    onLoadAdditionalPapers();
  }, [onLoadAdditionalPapers]);
  return { onLoadAdditionalPapers };
}
